import { Sound } from "react-sounds";
import soundtrackDict, { Soundtrack } from "@/shared/sounds";

type SoundProps = Omit<React.ComponentProps<typeof Sound>, "name"> & {
  name: Soundtrack;
};

export default function SoundCore({ name, options, ...props }: SoundProps) {
  const sound = soundtrackDict[name];

  // TODO: тут пока не понятно какие настройки допом прокидывать
  return <Sound name={sound} options={{ volume: 0.3, ...options }} {...props} />;
}
